import type { PcmpProposalStudentClass, PcmpTimeline } from '../../types/pcmpProposal.types';
import { PcmpActivityHistory } from './PcmpActivityHistory';
import { PcmpProposalSection } from './PcmpProposalSection';
import { PcmpTimelineTrack } from './PcmpTimelineTrack';

interface PcmpProposalTimelineProps {
  timeline: PcmpTimeline;
  students: PcmpProposalStudentClass[];
}

/** Approval tracks (marketing, then office) and the activity history. */
export function PcmpProposalTimeline({ timeline, students }: PcmpProposalTimelineProps) {
  const notes = [
    timeline.isFallbackMode ? 'Fallback mode: admins approve in place of the chain.' : null,
    timeline.isSubmitterInactive ? 'The submitting officer is inactive.' : null,
  ].filter((note): note is string => note !== null);

  return (
    <PcmpProposalSection title="Timeline">
      {notes.map((note) => (
        <p key={note} className="rounded-lg bg-warning px-4 py-2 text-sm text-warning-foreground">
          {note}
        </p>
      ))}
      <PcmpTimelineTrack
        title="Marketing approval"
        nodes={[timeline.mo, ...timeline.marketingChain, ...timeline.adminApprovers]}
        students={students}
      />
      <PcmpTimelineTrack
        title="Office approval"
        nodes={[timeline.mis, timeline.disbursement]}
        students={students}
      />
      <PcmpActivityHistory activity={timeline.activity} students={students} />
    </PcmpProposalSection>
  );
}
